// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2IaR_","download":"_1HiuC","downloadText":"_1QhSI","linkWeight":"_2S_Kh"};